import { render, staticRenderFns } from "./ShopOrderList.vue?vue&type=template&id=f194863a&scoped=true&"
import script from "./ShopOrderList.vue?vue&type=script&lang=js&"
export * from "./ShopOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrderList.vue?vue&type=style&index=0&id=f194863a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f194863a",
  null
  
)

export default component.exports